import { render, staticRenderFns } from "./PreferenceModal.vue?vue&type=template&id=bdc563a6&scoped=true"
import script from "./PreferenceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreferenceModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PreferenceModal.vue?vue&type=style&index=0&id=bdc563a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc563a6",
  null
  
)

export default component.exports